export const N70_02 = {
    "columns": 6,
    "rows": 3,
    "visual": {
        "id": 1,
        "type": "bar",
        "title": "Product Sales",
        "colorTheme": 'colorTheme1',
        "orientation": "horizontal",
        "xAxis": "Sales",
        "yAxis": "",
        "binding": {
            "data": {
                "series": [
                    {
                        "name": 'Sales',
                        "value": 'ActualSales',
                        "type": 'column'
                    }
                ],
                "title": "ItemName",
                "endpoint": "N70.2",
                "parameters": [
                    { "key": "FromMonth", "value": "" },
                    { "key": "FromYear", "value": "" },
                    { "key": "ToMonth", "value": "" },
                    { "key": "ToYear", "value": "" },
                    { "key": "RegionCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                        "selectedValueColumn": "ItemName",
                        "selectedTitle": "Customer Group",
                        "visual": [
                            {
                                "columns": 12,
                                "rows": 3,
                                "visual": {
                                    "id": 1,
                                    "type": "bar",
                                    "title": "Customer Group",
                                    "colorTheme": 'colorTheme2',
                                    "orientation": "horizontal",
                                    "xAxis": "Sales",
                                    "yAxis": "",
                                    "binding": {
                                        "data": {
                                            "series": [
                                                {
                                                    "name": 'Sales',
                                                    "value": 'ActualSales',
                                                    "type": 'column'
                                                }
                                            ],
                                            "title": "CustomerGroup",
                                            "endpoint": "N70.3",
                                            "parameters": [
                                                { "key": "FromMonth", "value": "" },
                                                { "key": "FromYear", "value": "" },
                                                { "key": "ToMonth", "value": "" },
                                                { "key": "ToYear", "value": "" },
                                                { "key": "ItemName", "value": "" },
                                                { "key": "RegionCode", "value": "" },
                                                { "key": "ConfigTypeCode", "value": "" }
                                            ]
                                        },
                                        "context": {
                                            "point": {
                                                "onClick": {
                                                    "selectedValueColumn": "ItemNameCustomerGroup",
                                                    "selectedTitle": "Customer Name",
                                                    "visual": [
                                                        {
                                                            "columns": 12,
                                                            "rows": 3,
                                                            "visual": {
                                                                "id": 1,
                                                                "type": "advancedTable",
                                                                "colorTheme": 'colorTheme1',
                                                                "title": "Customer Sales",
                                                                "binding": {
                                                                    "data": {
                                                                        "columns": [
                                                                            {
                                                                                "name": 'Customer Name',
                                                                                "columnName": 'CustomerName',
                                                                                "width": '500px',
                                                                                "align": "left",
                                                                                "sortable": true,
                                                                                "sum": false,
                                                                            },
                                                                            {
                                                                                "name": 'Actual Sales',
                                                                                "columnName": 'ActualSales',
                                                                                "width": '160px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true,
                                                                            },
                                                                            {
                                                                                "name": 'LY Sales',
                                                                                "columnName": 'LYSales',
                                                                                "width": '160px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true,
                                                                            },
                                                                            {
                                                                                "name": 'Growth %',
                                                                                "columnName": 'Growth',
                                                                                "width": '160px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "percent": true
                                                                            }
                                                                        ],
                                                                        "title": "CustomerName",
                                                                        "endpoint": "N70.4",
                                                                        "parameters": [
                                                                            { "key": "FromMonth", "value": "" },
                                                                            { "key": "FromYear", "value": "" },
                                                                            { "key": "ToMonth", "value": "" },
                                                                            { "key": "ToYear", "value": "" },
                                                                            { "key": "ItemNameCustomerGroup", "value": "" },
                                                                            { "key": "RegionCode", "value": "" },
                                                                            { "key": "ConfigTypeCode", "value": "" }
                                                                        ]
                                                                    },
                                                                    "context": {
                                                                        "point": {
                                                                            "onClick": {

                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        ]
                    }
                }
            }
        }
    }
}